// Global, permanent user preference: silence all proactive SuggestionCards.
//
// Decoupled from the guide phase on purpose — workflow nudges (audit/drill)
// are useful to experts, not onboarding hand-holding, so they show regardless
// of phase. This switch is the dedicated, user-controlled opt-out, toggled
// from the Guides catalog drawer footer. Persisted in localStorage; survives
// reload. `suggestions:pref-change` lets live surfaces react without a reload.

const KEY = "paperchase-suggestions-disabled";

export const SUGGESTIONS_PREF_EVENT = "suggestions:pref-change";

export function areSuggestionsDisabled(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setSuggestionsDisabled(disabled: boolean): void {
  if (typeof window === "undefined") return;
  try {
    if (disabled) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    // ignore — pref is best-effort
  }
  window.dispatchEvent(new CustomEvent(SUGGESTIONS_PREF_EVENT));
}
